// @flow
import styled from 'styled-components';

export const TransactionButtonsWrapper = styled.div`
	button {
		display: block;
		margin: .5em auto;
		min-width: 150px;
	}
`;

export default TransactionButtonsWrapper;


// WEBPACK FOOTER //
// ./src/components/Trades/TransactionButtonsWrapper.js